import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExcelService } from './_services/excel.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [ExcelService]
})
export class CoreModule { }
